/** Login 관련 modal */
const LOGIN = {
  LOGIN_TITLE: `Connect K STADIUM Wallet`,
  LOGIN_CONTENT: `Please sign into the account created through the K STADIUM app.\nYou may check your ID and PW in the K STADIUM app.`,

  LOGIN_SUCCESS_TITLE: `Wallet connection completed`,
  LOGIN_SUCCESS_CONTENT: `Successful logged in.\nBased on your consent to access your KSTADIUM wallet\nfrom the K STADIUM bridge.\nclick the OK button to proceed to the next step.
`,

  LOGIN_FAIL_TITLE: `Sign in failed`,
  LOGIN_FAIL_CONTENT: `Sign in failure.\nPlease re-check your ID and PW.`,
};

/** Timeout 관련 modal */
const TIMEOUT = {
  TIMEOUT_TITLE: `Transaction Timeout`,
  TIMEOUT_CONTENT: `For safe transactions, you will be automatically signed out because there is no service use for about an hour.
  If the transaction is going on in the wallet, please cancel the transaction and proceed from the beginning.
  (If you have proceeded to the approval stage of the Approve, there will be no additional approval for the approved amount.)
  If you have completed all the transactions, please check the progress in History.`,
};

export { LOGIN, TIMEOUT };
